import { render } from "./CompleteProfile.vue?vue&type=template&id=a619e1b6"
import script from "./CompleteProfile.vue?vue&type=script&lang=js"
export * from "./CompleteProfile.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__